export function register() {
  if (process.env.NODE_ENV !== "production") {
    return;
  }

  if (!("serviceWorker" in navigator)) {
    return;
  }

  // Public creator pages should not sit behind a controlling worker.
  // A normal Chrome profile otherwise pays SW claim/update cost that a fresh
  // incognito window never has, and a stale worker can serve HTML as JS.
  if ((window as unknown as { __BROWSABLE_LIGHT_SHELL__?: boolean }).__BROWSABLE_LIGHT_SHELL__) {
    unregister();
    return;
  }

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
      .then((reg) => {
        // Check for updates periodically while the tab is open
        setInterval(() => {
          reg.update().catch(() => undefined);
        }, 60 * 60 * 1000);
      })
      .catch((err) => {
        console.warn("SW registration failed:", err);
      });
  });
}

export function unregister() {
  if (!("serviceWorker" in navigator)) {
    return;
  }

  // Do not wait on `ready`: with no registration it can hang, and the
  // controlling worker is what slows the current public-page load.
  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => Promise.all(regs.map((reg) => reg.unregister())))
    .catch(() => undefined);
}
